import {WebConfiguration} from '@package/shared'

const request = new XMLHttpRequest()
request.open('GET', '/config.json', false)
request.send()

export const config = WebConfiguration.parse(JSON.parse(request.responseText))
